export default __webpack_public_path__ + "static/it2-beeb64dc4b17e27ba5c4404f2be72f8b.jpg";